import { readStoreFromPathname } from "@go-novus/admin-api";

/**
 * 页面绑定店铺取自 `/stores/<店铺>/…`，内嵌时前面增加 `/app/console`。
 * 同一浏览器可以同时开着多家店的后台，地址里的这一段就是这个标签页
 * 唯一的店铺依据：API 请求头、本地存储键都从它派生。
 * 地址不在店铺前缀下时返回 null，调用方该走「从 Shopify 打开」的提示。
 */
export function boundShopDomain(): string | null {
  return readStoreFromPathname(window.location.pathname);
}
